import React from 'react'
import { IconButton } from '@/components/commons'
import Link from 'next/link'

export const SearchButton = ({ className = '' }: { className?: string }) => {
  return (
    <div className={className}>
      <Link href="/search">
        <IconButton icon="SearchIcon" />
      </Link>
    </div>
  )
}
